var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "-1 -1 18 18",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.337 12.898c0 .18-.147.327-.327.327H7.02a.327.327 0 01-.326-.327v-1.96c0-.179.147-.326.326-.326h1.99c.18 0 .327.147.327.327v1.959zM8 0a8 8 0 100 16A8 8 0 008 0zm1.861 7.89c-.631.412-.82.768-.84 1.583a.163.163 0 01-.164.16H7.184c-.045 0-.164-.12-.164-.164v-.666c0-.698.377-1.312 1.154-1.879.06-.041.642-.421.642-.946 0-.435-.328-.738-.796-.738-.668 0-1.04.335-1.076.973a.163.163 0 01-.163.154H5.02a.164.164 0 01-.163-.172c.092-1.774 1.244-2.79 3.164-2.79 1.455 0 3.023.789 3.023 2.523 0 1.162-.266 1.382-1.184 1.962z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/QuestionMark.f7625b4535124a4cd5f2f035e5fdaee7.svg";